<template>
  <div class="animated fadeIn">
    <b-card v-if="show">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Top log {{so.perPage}}
      </template>
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="5">
            From
            <b-form >
              <date-picker v-model="so.opt.from" style="width: 80%" :lang="datepicker" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="5">
            To
            <b-form >
              <date-picker v-model="so.opt.to" style="width: 80%" :lang="datepicker" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>METHOD</span> </b-form> </b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="GET" value="GET" v-model="so.opt.method" @click="so.sk='request'"> <label for="GET">GET</label></b-form></b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="POST" value="POST" v-model="so.opt.method" @click="so.sk='request'"> <label for="POST">POST</label> </b-form> </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Response</span> </b-form> </b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="DetectionOnly" value=0 v-model="so.opt.is_block" @click="so.sk='is_block'"> <label for="DetectionOnly"><b-badge variant="warning">DetectionOnly</b-badge></label></b-form></b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="Block" value=1 v-model="so.opt.is_block" @click="so.sk='is_block'"> <label for="Block"><b-badge variant="danger">Block</b-badge></label> </b-form> </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Attacker</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_remote_addr" v-model="so.opt.remote_addr" :placeholder="'typing attacker'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Target</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_target" v-model="so.opt.target" :placeholder="'typing target'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Detect message</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_message" v-model="so.opt.message" :placeholder="'typing detect message'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>URI</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_uri" v-model="so.opt.uri" :placeholder="'typing URI'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh">Search</b-button>
          <b-button size="sm" variant="secondary" @click="reset">Reset</b-button>
          <b-button size="sm" variant="default" @click="so.sv=so.sk=''; so.adv = false; reset">Exit</b-button>
        </b-form-group>
      </b-card>

      <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
          Real-time refresh interval
          <select v-model="sync.interval" @change="refresh">
            <option disabled value="15">Please select interval : Default 15</option>
            <option value=10>10</option>
            <option value=30>30</option>
            <option value=60>60</option>
            <option value=300>300(5 min)</option>
          </select>
          sec
        </span>
        <span class="float-right">
          <i :class="`fa fa-refresh ${sync.th && !sync.stop ? 'fa-spin' : ''}`"></i>
          <b-btn @click="pause" size="sm" variant="warning">Pause</b-btn>
        </span>
      <hr>
      <b-row>
        <b-col sm="6">
          Show count
          <select v-model="so.perPage" @change="refresh">
            <option disabled value="15">Show count : Default 15</option>
            <option value=10>10</option>
            <option value=50>50</option>
            <option value=100>100</option>
          </select>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='remote_addr';so.skt=`Attacker`">Attacker</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt=`Target`">Target</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='message';so.skt='Rule'">Rule</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='uri';so.skt='URI'">URI</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = true; set()"><i class="fa fa-search-plus"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list"
        show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="castle" slot-scope="row">{{row.item.castle && row.item.castle.nickname ? row.item.castle.nickname : '-'}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="remote_addr" slot-scope="row">{{row.item.remote_addr}}</template>
        <template slot="target" slot-scope="row">{{row.item.target}}</template>
        <template slot="protocol" slot-scope="row">{{row.item.protocol}}({{row.item.method}})</template>
        <template slot="is_block" slot-scope="row">
          <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
          <b-badge v-else variant="warning">DetectionOnly</b-badge>
        </template>
        <template slot="uri" slot-scope="row">{{row.item.uri}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <!-- <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"/> -->
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker';
import datepicker from '@/custom';
import moment from 'moment-timezone';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
});

export default {
  data: () => {
    return {
      datepicker,
      show: true,
      so : default_opt(),
      sync : { interval : 15, stop : false, th : undefined },
    }
  },
  components: {
    DatePicker,
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
        { key: 'created_at', label: 'Date', sortable: true, thStyle: 'width: 10%' },
        { key: 'remote_addr', label: 'Attacker', sortable: true, thStyle: 'width: 10%' },
        { key: 'target', label: 'Target', sortable: true, thStyle: 'width: 10%' },
        { key: 'protocol', label: 'PROTOCOL', sortable: false, thStyle: 'width: 10%' },
        { key: 'method', label: 'METHOD', sortable: false, thStyle: 'width: 10%' },
        { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 10%' },
        { key: 'uri', label: 'URI', sortable: false, thStyle: 'width: 10%' },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
    }
  },
  methods: {
    set() { this.so.opt.from = moment().format('YYYY-MM-DD'); this.so.opt.to = moment().format('YYYY-MM-DD'); },
    reset() { this.so = default_opt(); this.so.opt.from = ''; this.so.opt.to = ''; this.refresh(); },
    refresh() {
      if((!this.sync.stop || this.so.adv) && this.$refs._list) {
        this.$refs._list.refresh();
        console.log('webcastle log refresh', new Date());
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'webcastle.log',
        cmd : 'list',
        offset : this.so.currentPage-1 || 0,
        limit :  Number(this.so.perPage),
        body: {
          and : [],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      so.offset = so.offset * so.limit;
      if(so.opt.from) { so.opt.from = moment(so.opt.from).format(); }
      if(so.opt.to) { so.opt.to = moment(so.opt.to).add(1, 'day').format(); }
      if(this.so.adv && so.opt && !(so.opt.to && so.opt.from)) { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)('Search Error', 'Range is not valid'); }
      if(this.so.adv){
        so.body.and = [];
        Object.keys(this.so.opt).forEach(k => {
          if(this.so.opt[k] === '') { return; }
          if(!(k == 'from' || k == 'to' || k == 'is_block')) { so.body.and.push({ "name" : k, "value" : this.so.opt[k], "op" : 'like' }) }
          else {
            if(k == 'from') { so.body.and.push({ "name" : 'created_at', "value" : moment(this.so.opt[k]), "op" : '>=' }) }
            if(k == 'to') { so.body.and.push({ "name" : 'created_at', "value" : moment(this.so.opt[k]).add(1, 'day'), "op" : '<' }) }
            if(k == 'is_block' && this.so.opt[k] == '1') { so.body.and.push({ "name" : 'is_block', "value" : true, "op" : '=' }) }
            if(k == 'is_block' && this.so.opt[k] == '0') { so.body.and.push({ "name" : 'is_block', "value" : false, "op" : '=' }) }
          }
        })
      } else {
        if(this.so.sk && this.so.sv) { so.body.and.push({ "name" : this.so.sk, 'value' : this.so.sv, 'op' : "=" }) }
      }
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
      return Api.Manager(so).then(rs => {
        this.so.totalRows = rs.total;
        if(rs.body > 0){
          for (let i = 0; i < rs.body.length; i++) {
            let r = rs.body[i];
            if(!r.headers) { r.reqTarget = ''; return '' }
            const headers = r.headers.split('\n');
            let reqTarget = '';
            for (let i = 0; i < headers.length; i++) {
              const line = headers[i].replace(/\s/, '').toLowerCase();
              if(line.indexOf('host') == -1) { continue;  }
              reqTarget = line.replace('host:', '');
            }
            r.reqTarget = reqTarget && reqTarget != r.target ? reqTarget : '';
          }
        }
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); if(this.sync.stop) { this.so.adv = false; } },
    detail: function(item) { console.log(item); this.$router.push(`log/${item.id}`); },
  	hideList: function(e) {
      this.show = !e; console.log('dashboard.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created: function() { console.log('dashboard.vue', 'created'); },
  destroyed: function() { console.log('dashboard.vue', 'destroyed'); this.sync.th = undefined; },
  mounted: function() { console.log('dashboard.vue', 'mounted'); },
}
</script>
